// PageProjectSetting Component

import React from 'react'
import async from 'async'

import app from '../../../app.jsx'
import ProjectSettingForm from '../../form/form_project_setting/form_project_setting.jsx'
import Typo from '../../../common/typography/typo/typo.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import BaseSettings from '../../page/base_setting/base_setting.jsx'

class PageProjectSetting extends BaseSettings {
  constructor (props) {
    super(props, 'setting-project', 'setting-user', 'setting-project')

    this._references = {
      pageHeader: React.createRef()
    }

    this.state = {
      isLoading: true,
      dataDate: null
    }

    this.data = {
      projectsetting: null
    }

    this._bUnMounted = false
  }

  componentDidMount () {
    this._getData()
  }

  /* Render Function */
  renderContent () {
    const { projectSetting } = this.data
    return (
      <div className='page-projectsetting'>
        <div className='colleft'>
          <Typo className='profile'>
            <h2>
              <IntlMessage ident='setting.project.contentTitle' />
            </h2>
            {this.props.showQuickbook ? (
              <div>
                <IntlMessage
                  ident='setting.project.contentInfoAlt'
                  html
                />
              </div>
            ) : (
              <p>
                <IntlMessage ident='setting.project.contentInfo' />
              </p>
            )}
          </Typo>
        </div>
        <div className='colright'>
          {projectSetting && (
            <ProjectSettingForm
              data={projectSetting || {}}
              onSubmit={this._onFormSubmit.bind(this)}
            />
          )}
        </div>
      </div>
    )
  }

  _reloadData () {
    this._getData()
  }

  getContentClassname () {
    return 'alt'
  }

  /* Private Functions */
  _getData () {
    async.series(
      [
        (done) => {
          this._getPageData(done)
        },
        (done) => {
          this._getDataProjectSetting(done)
        }
      ],
      (err, _res) => {
        this._onDataReceived(err)
      }
    )
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageProjectSetting: _onDataReceived Error', err)
    } else {
      app.debug('PageProjectSetting: _onDataReceived [done]')
    }
    this.setState({ isLoading: !!err, dataDate: new Date() })
  }

  _getDataProjectSetting (callback) {
    app.debug('PageProjectSetting: _getDataProjectSetting [start]')

    const teamId = app.getTeamId()
    app
      .service('/api/page/projectsetting')
      .get(teamId, {})
      .then((result) => {
        this.data.projectSetting = result
        callback(null)
      })
      .catch((err) => {
        app.debug('PageProjectSetting: _getDataProjectSetting err', err)
        callback(err)
      })
  }

  _onFormSubmit (data) {
    const teamId = app.getTeamId()
    app
      .service('/api/page/projectsetting')
      .update(teamId, data, {})
      .then((settingRes) => {
        app.setProjectSetting(settingRes)
      })
      .catch((err) => {
        app.debug('FormSubmit: _onFormSubmit err', err)
      })

    if (this._references.pageHeader.current) {
      this._references.pageHeader.current.showSuccess(
        'setting.project.msgSuccessTitle',
        'setting.project.msgSuccessContent'
      )
    }
  }
}

export default PageProjectSetting
